(function () {
  function isTypingInField(element) {
    return (
      element &&
      (
        element.tagName === 'INPUT' ||
        element.tagName === 'TEXTAREA' ||
        element.tagName === 'SELECT' ||
        element.isContentEditable
      )
    );
  }

  function getVisibleThumbnails(mediaGallery) {
    return Array.from(
      mediaGallery.querySelectorAll(
        '.thumbnail-list__item:not(.product__media-item--variant):not([hidden])'
      )
    ).filter(function (item) {
      return item.offsetParent !== null;
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (isTypingInField(document.activeElement)) return;

    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return;

    const mediaGallery = productInfo.querySelector('media-gallery');
    if (!mediaGallery) return;

    const thumbnails = getVisibleThumbnails(mediaGallery);
    if (thumbnails.length < 2) return;

    let currentIndex = thumbnails.findIndex(function (item) {
      const button = item.querySelector('button.thumbnail');

      return (
        item.classList.contains('is-active') ||
        button?.getAttribute('aria-current') === 'true'
      );
    });

    if (currentIndex < 0) currentIndex = 0;

    const nextIndex =
      event.key === 'ArrowRight'
        ? Math.min(currentIndex + 1, thumbnails.length - 1)
        : Math.max(currentIndex - 1, 0);

    if (nextIndex === currentIndex) return;

    const targetButton = thumbnails[nextIndex].querySelector('button.thumbnail');
    if (!targetButton) return;

    event.preventDefault();
    targetButton.click();

    thumbnails[nextIndex].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  });
})();